import React, { useState } from 'react'
import { useNavigate } from "react-router-dom";

import { apiNames } from "services/api/endpoint.service";
import { postAxios } from "services/api/api.service";

import { setStorage } from "services/user/user.session.service";
import useSession from "hooks/useSession";
import useToast from 'hooks/useToast';

import { ConfirmMail, ConfirmRegister, PassValidation, PRecoverPasswordEmail, PRecoverPasswordId } from 'libs/raas-ui-react-components/src/components';
import { getConfirmRegisterLiterals, getLiterals, getPassValidationLiterals, getPRecoverPasswordEmail, getPRecoverPasswordIdLiterals } from './utils';
import { useTranslation } from 'react-i18next';

export const RecoverPasswordFlow = () => {
    const [t, i18n] = useTranslation("recoverPasswordFlow");
    const navigate = useNavigate();
    const { openToast } = useToast();

    const [step, setStep] = useState(0);

    const [email, setEmail] = useState("");
    const [obfuscateEmail, setObfuscateEmail] = useState(null);

    const [idDocument, setIdDocument] = useState("");
    const [validationToken, setVT] = useState("");
    const [codeVerification, setCodeVerification] = useState("");

    const handleExit = () => {
        navigate("/")
    }
    const handleNextPage = () => {
        navigate("/login");
    }
    const handleBackPage = () => {
        if (step === 2) {
            if (email) {
                setStep(0)
            } else {
                setStep(1);
            }
        } else {
            setStep(step - 1);
        }
    }
    /* OK */
    const handleVerify = (data: any) => {
        const Email = data?.detail?.email;
        const IdDoc = data?.detail?.idDocument;

        Email && setEmail(Email);
        IdDoc && setIdDocument(IdDoc);

        if (Email || IdDoc) {
            let body = IdDoc ? { identificationDocument: IdDoc } : { email: Email };
            if (body?.identificationDocument?.type == "Pasaporte") body.identificationDocument.type = "PASS";
            if (body) {
                postAxios(apiNames.IDENTITY, false, "/customers/forgot-password", body)
                    .then((response: any) => {
                        if (response?.data?.email) setObfuscateEmail(response?.data?.email)
                        openToast("success", t('literal.emailSent'), `Busca tu código en ${(data?.detail?.email) ? data?.detail?.email : (response?.data?.email) ? response?.data?.email : t('literal.yourEmail')}`)
                        setVT(response?.data?.token);
                        setStep(2);
                    })
                    .catch((error) => {
                        if (Math.floor(error?.status / 100) === 4) {
                            openToast("error", t('literal.emailSent'), t('literal.anErrorHasOccurred'));
                        }
                    })
            }

        }
    }
    const sendVerification = () => {
        if (email || idDocument) {
            let body = idDocument ? { identificationDocument: idDocument } : { email };
            if (body) {
                postAxios(apiNames.IDENTITY, false, "/customers/forgot-password", body)
                    .then((response: any) => {
                        openToast("success", t('literal.emailSent'), t('literal.findYourCodeIn') + t('literal.yourEmail') + email);
                        setVT(response?.data?.token);
                    })
                    .catch((error) => {
                        if (Math.floor(error?.status / 100) === 4) {
                            openToast("error", t('literal.emailSent'), t('literal.anErrorHasOccurred'));
                        }
                    })
            }

        }
    }
    /* OK */
      const handleVerifyCode = (data: any) => {
        if (data.detail) {
            setCodeVerification(data.detail);
            setStep(step + 1);
        }
        // if (data.detail) {
        //     setCodeVerification(data.detail);
        //     let body = {
        //         token: validationToken,
        //         code: data.detail
        //     };
        //     postAxios(apiNames.IDENTITY, false, "/customers/verification-forgot-password", body).then((response: any) => {
        //         setVT(response?.data?.token);
        //         setStep(step + 1);
        //     }).catch((error) => {
        //         if (Math.floor(error?.status / 100) === 4) {
        //             openToast("error", t('literal.emailSent'),  t('literal.anErrorHasOccurred'));
        //         }
        //     })
        // }
    }
    /* OK */
    const handlePasswordPage = (data: any) => {
        let password = data.detail
        if (password) {
            let body = {
                token: validationToken,
                password,
                code: codeVerification
            };
            postAxios(apiNames.IDENTITY, false, "/customers/confirm-forgot-password", body).then((response: any) => {
                setStep(step + 1);
            }).catch((error) => {
                if (Math.floor(error?.status / 100) === 4) {
                    openToast("error", t('literal.emailSent'), t('literal.anErrorCode'));
                }
            })
        }
    }

    const getComponent = (currentStep: number) => {

        switch (currentStep) {
            case 0:
                return <PRecoverPasswordEmail
                    literals={getPRecoverPasswordEmail(t)}
                    onExitPage={handleExit}
                    onNextPage={handleVerify}
                    onGoIdPage={() => setStep(1)}
                />
            case 1:
                return <PRecoverPasswordId
                    literals={getPRecoverPasswordIdLiterals(t)}
                    onExitPage={handleExit}
                    onNextPage={handleVerify}
                    onBackPage={handleBackPage}
                    onGoEmailPage={() => setStep(0)} />
            case 2:
                return <ConfirmMail
                    recover-password={email ? false : true}
                    literals={getLiterals(t)}
                    mail={obfuscateEmail ? obfuscateEmail : email}
                    onExitPage={handleExit}
                    onVerifyEmail={handleVerifyCode} // DUDA: ¿cómo puedo verificar sin el mail?
                    onResendMail={sendVerification}
                    onOpenMail={() => { }}
                    onBackPage={handleBackPage} />
            case 3:
                return <PassValidation
                    literals={getPassValidationLiterals(t)}
                    onExitPage={handleExit}
                    onConfirmPass={handlePasswordPage} />
            case 4:
                return <ConfirmRegister
                    literals={getConfirmRegisterLiterals(t)}
                    onExitPage={handleExit}
                    onNextPage={handleNextPage} />
        }
    }

    return (
        <>
            <div className="m-2">
                {getComponent(step)}
            </div>
        </>
    )
}
